"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProperty = exports.updateObject = exports.trimObject = exports.objectMapper = void 0;
function objectMapper(value, changePropertyName, changeValue) {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const clonedValue = Object.assign({}, value);
        const result = {};
        for (const [propertyName, propertyValue] of Object.entries(clonedValue)) {
            const propertyNameToUse = changePropertyName ?
                changePropertyName(propertyName) :
                propertyName;
            if (typeof propertyValue === "object" && propertyValue !== null) {
                result[propertyNameToUse] = objectMapper(propertyValue, changePropertyName, changeValue);
            }
            else {
                const propertyValueToUse = changeValue ?
                    changeValue(propertyValue, propertyName) :
                    propertyValue;
                result[propertyNameToUse] = propertyValueToUse;
            }
        }
        return result;
    }
    else if (Array.isArray(value)) {
        const clonedValue = [...value];
        return clonedValue.map((arrayItem) => objectMapper(arrayItem, changePropertyName, changeValue));
    }
    return (changeValue ? changeValue(value) : value);
}
exports.objectMapper = objectMapper;
function trimObject(value, propertyPathsToKeep) {
    for (const property of propertyPathsToKeep !== null && propertyPathsToKeep !== void 0 ? propertyPathsToKeep : []) {
        const parts = property.split(".");
        while (parts.pop()) {
            if (parts.length === 0) {
                continue;
            }
            const parentPortion = parts.join(".");
            if (propertyPathsToKeep === null || propertyPathsToKeep === void 0 ? void 0 : propertyPathsToKeep.includes(parentPortion)) {
                continue;
            }
            propertyPathsToKeep === null || propertyPathsToKeep === void 0 ? void 0 : propertyPathsToKeep.push(parentPortion);
        }
    }
    const trimer = (_value, parentPath) => {
        if (_value === null ||
            (typeof _value !== "object" && !Array.isArray(_value))) {
            return;
        }
        for (const property in _value) {
            if (!Object.prototype.hasOwnProperty.call(_value, property)) {
                continue;
            }
            let fullPropertyPath = "";
            if (Array.isArray(_value)) {
                fullPropertyPath = parentPath !== null && parentPath !== void 0 ? parentPath : "";
            }
            else {
                fullPropertyPath =
                    parentPath ? `${parentPath}.${property}` : property;
            }
            if (_value[property] === null || _value[property] === undefined) {
                delete _value[property];
            }
            else if (propertyPathsToKeep &&
                !(propertyPathsToKeep === null || propertyPathsToKeep === void 0 ? void 0 : propertyPathsToKeep.includes(fullPropertyPath))) {
                delete _value[property];
            }
            else if (typeof _value[property] === "object" ||
                Array.isArray(_value)) {
                trimer(_value[property], fullPropertyPath);
            }
        }
    };
    trimer(value);
    return value;
}
exports.trimObject = trimObject;
function updateObject(destinationObject, sourceObject, deleteNullish = false, deleteEmptyStrings = false) {
    for (const [k, v] of Object.entries(sourceObject)) {
        updateProperty(destinationObject, k, v, deleteNullish, deleteEmptyStrings);
    }
}
exports.updateObject = updateObject;
function updateProperty(obj, property, value, deleteNullish = false, deleteEmptyStrings = false) {
    if (deleteNullish && (value === null || value === undefined)) {
        delete obj[property];
        return;
    }
    if (typeof value === "string") {
        const trimmedValue = value.trim();
        if (deleteEmptyStrings && !trimmedValue) {
            delete obj[property];
            return;
        }
        value = trimmedValue;
    }
    obj[property] = value;
}
exports.updateProperty = updateProperty;
//# sourceMappingURL=objectUtilities.js.map